import React from 'react';
import { pxToRem } from '../util';
const CardHeader = ({
  title = '',
  subtitle = '',
}: {
  title?: string;
  subtitle?: string;
}) => {
  const color = 'rgb(206, 234, 255)';
  return (
    <div
      style={{
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        fontSize: pxToRem(18),
      }}
    >
      <span>{title}</span>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          {subtitle}
        </span>
        <div
          style={{
            display: 'flex',
            gap: '5px',
          }}
        >
          <div
            style={{
              width: '80px',
              height: '15px',
              backgroundColor: 'rgba(41, 51, 65, 0.6)',
            }}
          ></div>
          <div
            style={{
              width: '15px',
              height: '15px',
              backgroundColor: 'rgba(169, 179, 196, 0.6)',
            }}
          ></div>
          <div
            style={{
              width: '15px',
              height: '15px',
              backgroundColor: 'rgba(74, 107, 147, 0.6)',
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
export default CardHeader;
